import { useTranslation } from 'react-i18next';
import { LANGUAGES } from '@/i18n/languages';
import { markManualLanguage } from '@/i18n/manualLanguage';

export function LanguageSwitcher() {
  const { i18n } = useTranslation();
  const current = (i18n.language || 'en').split('-')[0];

  return (
    <label className="relative inline-flex items-center text-sm">
      <span className="sr-only">{i18n.t('common.language')}</span>
      <select
        value={current}
        onChange={(e) => {
          markManualLanguage();
          void i18n.changeLanguage(e.target.value);
        }}
        className="appearance-none rounded-md border border-ink-200 bg-white px-2.5 py-1.5 pr-7 text-sm text-ink-700 hover:border-ink-300 focus:outline-none focus:ring-2 focus:ring-accent-500"
      >
        {LANGUAGES.map((l) => (
          <option key={l.code} value={l.code}>
            {l.flag} {l.nativeName}
          </option>
        ))}
      </select>
      <svg className="pointer-events-none absolute right-2 h-4 w-4 text-ink-400" viewBox="0 0 20 20" fill="currentColor">
        <path fillRule="evenodd" d="M5.23 7.21a.75.75 0 011.06.02L10 11.06l3.71-3.83a.75.75 0 111.08 1.04l-4.25 4.4a.75.75 0 01-1.08 0L5.21 8.27a.75.75 0 01.02-1.06z" clipRule="evenodd" />
      </svg>
    </label>
  );
}
